export const environment = {
  environment: 'stage',
  apiUrl: 'https://cplhydrotest-v2-api-stage1.chevron.com/api/',
  calSettings: {
    "autoSignIn": true,
    "popupForLogin": false,
    "cacheLocation": "localStorage",
    "instance": "https://login.microsoftonline.com/",
    "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    "clientId": "d02aead9-9c0d-475d-80f9-f951329e2417",
    "redirectUri": "https://cplhydrotest-v2-stage1.chevron.com/",
    "oidcScopes": [
      "openid",
      "profile",
      "email",
      "offline_access"
    ],
    // API access scopes
    "apiScopes": [
      "openid",
      "profile",
      "email",
      "offline_access",
      "https://cplhydrotest-prd.azure.chevron.com/user_impersonation"
    ],
    "graphScopes": [],
  },
  powerBi: {
    powerBiScopes: ["https://analysis.windows.net/powerbi/api/.default"], // not required in call Auth
    apiBase: 'https://api.powerbi.com/v1.0/myorg/groups'
  }

};
